export default "__VITE_ASSET__BetXL8ne__"